import React, { useEffect, useRef, useState } from 'react';
import './style.scss';
import clsx from 'clsx';
import Link from '../controls/link';
import useUserData from '../../contexts/userData';
import Copyright from '../general/copyright';
import SocialButtons from '../general/socialIcons';
import SVGLogout from '../../assets/images/icons/logout';

type MenuItem = {
  to?: string;
  hash?: string;
  title: string;
};

const loggedOutItems: MenuItem[] = [
  {
    hash: 'nft',
    title: 'nft',
  },
  {
    hash: 'gameplay',
    title: 'gameplay',
  },
  {
    hash: 'cream',
    title: 'hand cream',
  },
  {
    hash: 'roadmap',
    title: 'roadmap',
  },
  {
    hash: 'team',
    title: 'team',
  },
  {
    hash: 'info',
    title: 'info desk',
  },
];

const loggedInItems: MenuItem[] = [
  {
    to: '/',
    title: 'fight',
  },
  {
    to: '/market',
    title: 'hands market',
  },
  {
    to: '/creamshop',
    title: '$cream shop',
  },
  {
    to: '/about',
    title: 'about',
  },
];

interface Props {
  opened: boolean;
  onClose: () => any;
}

const AppMenu = ({ opened, onClose }: Props) => {
  const { loggedIn, logout } = useUserData();
  const initiating = useRef(true);
  const [className, setClassName] = useState('app-menu');

  useEffect(() => {
    if (initiating.current) {
      initiating.current = false;
    } else {
      setClassName(
        clsx('app-menu', opened ? 'app-menu-visible' : 'app-menu-hidden')
      );
      document.body.className = opened ? 'unscrollable' : '';
    }
    return () => {
      document.body.className = '';
    };
  }, [opened]);

  const items = loggedIn ? loggedInItems : loggedOutItems;

  return (
    <div className={className}>
      <div className='app-menu-content'>
        <div className='app-menu-items'>
          {items.map((item, index) => (
            <Link
              to={{ pathname: item.to || '/', hash: item.hash }}
              className='app-menu-item'
              onClick={onClose}
              key={index}
            >
              {item.title}
            </Link>
          ))}
        </div>
        {loggedIn && (
          <div
            className='app-menu-logout'
            onClick={() => {
              logout();
              onClose();
            }}
          >
            ESCAPE
            <SVGLogout
              className='app-menu-logout-icon'
              color={'#000'}
              size={30}
            />
          </div>
        )}
        <Copyright
          color='#000'
          minified
          className={clsx('app-menu-copyright', loggedIn && 'logged-in')}
        />
        <SocialButtons
          inverted
          className={clsx('app-menu-socials', loggedIn && 'logged-in')}
        />
      </div>
    </div>
  );
};

export default AppMenu;
